__turbopack_context__.v({
  "card-skeleton": "learn-content-carousel-skeleton-module-scss-module__8OdXcG__card-skeleton",
});
